// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Fay6","location":"Header_location__2eRGy"};